import s from './Label.module.css'

type Props = {
  children: React.ReactNode
}

export const Label = ({ children }: Props) => {
  return <label className={s.label}>{children}</label>
}
